export default "__VITE_ASSET__C9fb2Lxk__"